















































































































































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import LaporanOperasi from "@/services/LaporanOperasi";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import LaporanOperasiStore from "@/store/modules/LaporanOperasi";
import { LaporanOperasi as LapOpType } from "@/types/laporan_operasi";
import LaporanOperasiInput from "@/pages/pemeriksaan_ranap/LaporanOperasiInput.vue";
import PemantauanAnestesiPage from "@/pages/PemantauanAnestesiPage.vue";
import CardSerahTerimaOperasi from "@/components/pemeriksaan/tabs/rekam-medis/laporan-operasi/CardSerahTerimaOperasi.vue";
import LaporanOperasiRiwayat from "@/pages/pemeriksaan_ranap/LaporanOperasiRiwayat.vue";
import {
  laporanOperasiHeaders,
  namaTindakanLabel,
  tglOperasi
} from "@/utils/laporanOperasi";

@Component({
  components: {
    CardModalTtd,
    LaporanOperasiInput,
    PemantauanAnestesiPage,
    CardSerahTerimaOperasi,
    LaporanOperasiRiwayat
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class LaporanOperasiPage extends Vue {
  @Prop() readonly register!: number;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("laporan_operasi", "create");
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("laporan_operasi", "edit");
  }

  @Prop() readonly rm!: string;
  @Ref() readonly dateTimePicker: any;
  @Ref() readonly refJenisImplant!: HTMLInputElement;
  @Ref() opStartedAtPicker!: HTMLElement;
  @Ref() opEndedAtPicker!: HTMLElement;
  @Ref() refTglOperasi!: HTMLElement;
  @Ref() refTglSelesaiOperasi!: HTMLElement;
  @Ref() refOpTimeStartedAt!: HTMLElement;
  @Ref() refOpTimeEndedAt!: HTMLElement;
  @Ref() refDxPraOps!: HTMLElement;

  //tabel
  tblHeight = "900";

  get headers() {
    return laporanOperasiHeaders(this.inputShow);
  }

  mode: "daftar" | "riwayat" = "daftar";
  pemantauanAnestesiShow = false;
  inputShow = false;
  inputData: Partial<LapOpType> | null = null;

  namaTindakanLabel(item: LapOpType): string {
    return namaTindakanLabel(item);
  }

  saving = false;
  removing = false;

  mounted() {
    this.getByRegister();
  }

  get stateUser() {
    return userModule.user;
  }

  get jenisTindakanOptions() {
    return [
      { id: "emergensi", name: "Emergensi" },
      { id: "elektif", name: "Elektif" },
      { id: "odc", name: "ODC" }
    ];
  }

  get klasifikasiOptions() {
    return [
      { id: "khusus", name: "Khusus" },
      { id: "mayor", name: "Mayor" },
      { id: "medium", name: "Medium" },
      { id: "minor", name: "Minor" }
    ];
  }

  get lapOpList(): LapOpType[] {
    return LaporanOperasiStore.dataList || [];
  }

  get loading() {
    return LaporanOperasiStore.loading;
  }

  get canDelete() {
    return false;
  }

  tglOperasi(dateString: string | undefined): string {
    return tglOperasi(dateString);
  }

  previewForm(id: number) {
    LaporanOperasi.print(id);
  }

  openPemantauanAnestesi() {
    this.pemantauanAnestesiShow = true;
  }

  closePemantauanAnestesi() {
    this.pemantauanAnestesiShow = false;
  }

  editItem(item: LapOpType) {
    if (this.readOnly) return;
    this.inputData = JSON.parse(JSON.stringify(item));
    this.$nextTick(() => {
      this.inputShow = true;
    });
  }

  addNew() {
    if (this.readOnly) return;
    this.inputData = {};
    this.$nextTick(() => {
      this.inputShow = true;
    });
  }

  inputClose() {
    this.inputData = null;
    this.inputShow = false;
  }

  remove(id: number) {
    const conf = confirmRemove("Laporan Operasi");

    if (conf) {
      const item = this.lapOpList.find(itm => itm.id == id);
      item["isDeleting"] = true;

      LaporanOperasi.destroy(id)
        .then(resp => {
          if (resp.status == 1) {
            appModule.NoticeDelay("Berhasil menghapus Laporan Operasi");

            this.getByRegister();
          }
        })
        .finally(() => {
          item["isDeleting"] = false;
        });
    }
  }

  reload(activeData = null) {
    this.inputData = activeData;
    this.getByRegister();

    if (!activeData) {
      this.inputClose();
    }
  }

  async getByRegister() {
    await LaporanOperasiStore.getByRegister(this.register).then(() => {
      if (this.inputData) {
        this.inputData = (LaporanOperasiStore.dataList || []).find(
          itm => itm.id == this.inputData.id
        );
      }
    });
    //
  }
}
